<!-- Hero Start -->
<section class="home-slider position-relative" id="home">
    <ngb-carousel [showNavigationIndicators]="showNavigationIndicators">
        <ng-template ngbSlide>
            <div class="align-items-center"
                 style="background-size:cover; background-image:url('assets/3r/cover/students-1807505_640.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 text-center">
                            <div class="title-heading mt-4">
                                <!--                                <h6 class="text-light para-dark animated fadeInDownBig animation-delay-1">Private office and-->
                                <!--                                    Co-working space for <span class="text-success">$19</span></h6>-->
                                <h1 class="heading mb-3 text-white title-dark animated fadeInUpBig animation-delay-3">
                                    Excellence through learning</h1>
                                <!--                                <p class="para-desc text-light para-dark mx-auto animated fadeInUpBig animation-delay-7">Launch your-->
                                <!--                                    campaign and benefit from our expertise on designing and managing conversion centered bootstrap4-->
                                <!--                                    html page.</p>-->
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end carousel item-->
        </ng-template>
        <ng-template ngbSlide>
            <div class="align-items-center"
                 style="background-size:cover; background-image:url('assets/3r/cover/medium-shot-woman-taking-notes.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 text-center">
                            <div class="title-heading mt-4">
                                <!--                                <h6 class="text-light para-dark animated fadeInDownBig animation-delay-1">The Best Coworking in The-->
                                <!--                                    City</h6>-->
                                <h1 class="heading mb-3 text-white title-dark animated fadeInUpBig animation-delay-3">
                                    Everyone a learner everyday</h1>
                                <!--                                <p class="para-desc mx-auto text-light para-dark animated fadeInUpBig animation-delay-7">Launch your-->
                                <!--                                    campaign and benefit from our expertise on designing and managing conversion centered bootstrap4-->
                                <!--                                    html page.</p>-->

                                <!--end subscribe form-->
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end carousel item-->
        </ng-template>
        <ng-template ngbSlide>
            <div class="align-items-center"
                 style="background-size:cover; background-image:url('assets/3r/cover/people-2557396_640.jpg');">
                <div class="bg-overlay"></div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-12 text-center">
                            <div class="title-heading mt-4">
                                <!--                                <h6 class="text-light para-dark animated fadeInDownBig animation-delay-1">Our Space for You</h6>-->
                                <h1 class="heading mb-3 text-white title-dark animated fadeInUpBig animation-delay-3">
                                    Education – Your Door To The Future</h1>
                                <!--                                <p class="para-desc mx-auto text-light para-dark animated fadeInUpBig animation-delay-7">Launch your-->
                                <!--                                    campaign and benefit from our expertise on designing and managing conversion centered bootstrap4-->
                                <!--                                    html page.</p>-->
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
                <!--end container-->
            </div>
            <!--end carousel item-->
        </ng-template>
    </ngb-carousel>

    <!--end carousel inner-->

    <!-- </div> -->
</section>
<!-- Feature Start -->
<section class="section">

    <div class="container mt-100 mt-60 mb-5">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-6 mt-4 pt-2">
                <img style="width: 25rem" src="assets/3r/websites%20post%20newar%20description.jpg" alt="">
            </div>
            <!--end col-->

            <div class="col-lg-7 col-md-6 mt-4 pt-2">
                <div class="section-title ml-lg-5">
                    <h4 class="title mb-4">WELCOME TO 3R INTERNATIONAL</h4>
                    <p class="text-muted">We, 3R International, are the best overseas education consultant in the
                        industry today and help students, every step of the way, in achieving their dream international
                        degree.
                        <br>
                        Through our wide range of free support services, we guide students to their dream study
                        destination- by helping them find the courses, colleges and universities that meet their
                        expectations and needs-on a global level</p>
                    <!--                    <ul class="list-unstyled text-muted">-->
                    <!--                        <li class="mb-0"><span class="text-primary h5 mr-2"><i class="uim uim-check-circle"></i></span>Digital-->
                    <!--                            Marketing Solutions for Tomorrow-->
                    <!--                        </li>-->
                    <!--                        <li class="mb-0"><span class="text-primary h5 mr-2"><i class="uim uim-check-circle"></i></span>Our-->
                    <!--                            Talented-->
                    <!--                            & Experienced Marketing Agency-->
                    <!--                        </li>-->
                    <!--                        <li class="mb-0"><span class="text-primary h5 mr-2"><i class="uim uim-check-circle"></i></span>Create-->
                    <!--                            your-->
                    <!--                            own skin to match your brand-->
                    <!--                        </li>-->
                    <!--                    </ul>-->
                    <!--                    <div class="mt-4">-->
                    <!--                        <a href="javascript:void(0)" class="btn btn-primary">Read More-->
                    <!--                            <i-feather name="arrow-right" class="fea icon-sm"></i-feather>-->
                    <!--                        </a>-->
                    <!--                    </div>-->
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
    <div class="container">
        <!--        <div class="row justify-content-center">-->
        <!--            <div class="col-12 text-center">-->
        <!--                <div class="section-title mb-4 pb-2">-->
        <!--                    <h4 class="title mb-4 mt">What We Do ?</h4>-->
        <!--                    <p class="text-muted para-desc mx-auto mb-0">Start working with <span-->
        <!--                            class="text-primary font-weight-bold">Landrick</span> that can provide everything you need-->
        <!--                        to generate-->
        <!--                        awareness, drive traffic, connect.</p>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end col&ndash;&gt;-->
        <!--        </div>-->
        <!--end row-->

        <!--        <div class="row">-->
        <!--            <div class="col-md-4 col-12 mt-5">-->
        <!--                <div class="features text-center">-->
        <!--                    <div class="image position-relative d-inline-block">-->
        <!--                        <img src="assets/images/icon/pen.svg" class="avatar avatar-small" alt="">-->
        <!--                    </div>-->

        <!--                    <div class="content mt-4">-->
        <!--                        <h4 class="title-2">Design & Development</h4>-->
        <!--                        <p class="text-muted mb-0">Nisi aenean vulputate eleifend tellus vitae eleifend enim a Aliquam-->
        <!--                            aenean-->
        <!--                            elementum semper.</p>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end col&ndash;&gt;-->

        <!--            <div class="col-md-4 col-12 mt-5">-->
        <!--                <div class="features text-center">-->
        <!--                    <div class="image position-relative d-inline-block">-->
        <!--                        <img src="assets/images/icon/video.svg" class="avatar avatar-small" alt="">-->
        <!--                    </div>-->

        <!--                    <div class="content mt-4">-->
        <!--                        <h4 class="title-2">Management & Marketing</h4>-->
        <!--                        <p class="text-muted mb-0">Allegedly, a Latin scholar established the origin of the text by-->
        <!--                            established-->
        <!--                            compiling unusual word.</p>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end col&ndash;&gt;-->

        <!--            <div class="col-md-4 col-12 mt-5">-->
        <!--                <div class="features text-center">-->
        <!--                    <div class="image position-relative d-inline-block">-->
        <!--                        <img src="assets/images/icon/sand-clock.svg" class="avatar avatar-small" alt="">-->
        <!--                    </div>-->

        <!--                    <div class="content mt-4">-->
        <!--                        <h4 class="title-2">Real Time Zone</h4>-->
        <!--                        <p class="text-muted mb-0">It seems that only fragments of the original text remain in the Lorem-->
        <!--                            Ipsum texts-->
        <!--                            the original used today.</p>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            &lt;!&ndash;end col&ndash;&gt;-->
        <!--        </div>-->
        <!--end row-->
    </div>
    <!--end container-->
    <div class="container mt-100 mt-60">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="section-title mb-4 pb-2">
                    <h4 class="title mb-4">STUDY DESTINATIONS</h4>
                    <!--                    <p class="text-muted para-desc mx-auto mb-0">Start working with <span-->
                    <!--                            class="text-primary font-weight-bold">Landrick</span> that can provide everything you need-->
                    <!--                        to generate-->
                    <!--                        awareness, drive traffic, connect.</p>-->
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->

        <div class="row">
            <!--            <div class="col-lg-4 col-md-6 mt-4 pt-2" *ngFor="let d of (dest | slice: -3)">-->
            <div class="col-lg-12 col-md-6 mt-4">
                <owl-carousel-o id="customer-testi" [options]="customOptions">
                    <ng-template carouselSlide *ngFor="let d of dest" style="    padding-bottom: 25px;">
                        <!--                    <div class="media customer-testi m-2">-->
                        <div class="col-lg-12 col-md-12 mt-4 pt-2" style="    padding-bottom: 25px;">
                            <div class="card blog rounded border-0 shadow">
                                <div class="position-relative">
                                    <img src="data:image/png;base64,{{d.image}}" class="card-img-top rounded-top"
                                         alt="...">
                                    <div class="overlay rounded-top bg-dark"></div>
                                </div>
                                <div class="card-body content">
                                    <h5><a href="javascript:void(0)" class="card-title title text-dark">{{d.name}}</a>
                                    </h5>
                                    <p class="text-muted">{{d.description | slice:0:150}} ...</p>
                                    <button (click)="booking(d)" class="btn-sm btn  btn-primary mr-3">See more</button>
                                </div>

                            </div>
                        </div>
                        <!--                    </div>-->
                    </ng-template>
                </owl-carousel-o>
            </div>
            <!--end col-->

        </div>
        <!--end row-->
    </div>

    <div class="container mt-100 mt-60 mb-5">
        <div class="row align-items-center">

            <!--end col-->
            <div class="col-lg-12 col-md-12 mt-4 pt-2">
                <div class="section-title ml-lg-5">
                    <h4 class="title mb-4">NOTICE BOARD</h4>
                    <div style="max-height: 400px; overflow-y: scroll">
                        <div class="card mb-2" *ngFor="let n of note">
                            <div class="card-body">
                                <h5 class="text-primary"><b>{{n.title}}</b></h5>
                                <p class="text-muted">{{n.description}}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>


    <!--end container-->
</section>
<!--end section-->
<!-- Feature End -->

<!-- Testi Start -->
<section class="section" style="background: url('assets/images/3.jpg') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row py-5 justify-content-center">
            <div class="col-lg-8 text-center">
                <!-- <div id="owl-fade" class="owl-carousel owl-theme"> -->
                <owl-carousel-o i [options]="customOptions2">
                    <ng-template carouselSlide *ngFor="let r of review">
                        <div class="customer-testi text-center mx-4">
                            <img src="assets/3r/user-3331257__340.png"
                                 class="img-fluid avatar avatar-small rounded-circle mx-auto shadow"
                                 alt="">
                            <p class="text-light para-dark h5 font-weight-normal font-italic mt-4">"{{r.review}} "</p>
                            <!--                            <ul class="list-unstyled mb-0">-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                            </ul>-->
                            <h6 class="text-light title-dark"> {{r.clientName}} </h6>
                        </div>
                        <!--end customer testi-->
                    </ng-template>
                </owl-carousel-o>
                <!-- </div> -->
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->
</section>

<!--end section-->
<!-- Testi End -->

<!-- Shape Start -->
<div class="position-relative">
    <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
    </div>
</div>

<section>
    <div class="row mt-5 pt-md-4 mb-4 justify-content-center">
        <div class="col-1"></div>
        <div class="col-4">

            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F3R-International-435618260283762&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                    width="340" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0"
                    allowfullscreen="true"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
        </div>
        <div class="col-4 text-center">
            <div class="section-title">
                <h4 class="title mb-4">Have Question ? Get in touch!</h4>
                <a routerLink="/page-contact" class="btn btn-primary mt-4"><i class="mdi mdi-phone"></i> Contact
                    us</a>
            </div>
        </div>
        <div class="col-1"></div>
        <!--end col-->
    </div>
</section>
<!--Shape End-->

<!-- Shape Start -->
<!--<div class="position-relative">-->
<!--    <div class="shape overflow-hidden text-footer">-->
<!--        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>-->
<!--        </svg>-->
<!--    </div>-->
<!--</div>-->
<!--Shape End-->


<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-soft-primary back-to-top" id="back-to-top"
   [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
